<template>
  <div class="h-full grid grid-rows-[auto_auto_1fr] text-[#ABABAB]">
    <ThreadsNav show-back class="w-full">
      <template #center>
        <div class="text-base">{{ t(`story.role.chapter`) }}</div>
      </template>
    </ThreadsNav>

    <div class="flex justify-end mb-3">
      <button
        class="btn btn-xs rounded"
        @click="$router.push(`/story/edit/role/add`)"
      >
        {{ t(`story.role.add`) }}
      </button>
    </div>

    <div class="overflow-auto">
      <div
        class="flex gap-4 my-3 px-3"
        v-for="(item, idx) in store.currentStoryMateList"
      >
        <div class="flex flex-col items-center">
          <UserAvatar
            class="w-[100px] aspect-[3/4] mb-4"
            :avatar-url="item.mediaUrl"
            alt=""
          />
          <p>{{ item.name }}</p>
        </div>
        <div class="flex-1 flex flex-col">
          <VanField
            class="bg-[#1a1a1a] border border-[#2f2f2f] rounded mb-2"
            v-model="columnsMap[item.role! as 1|2]"
            is-link
            readonly
            name="picker"
            :placeholder="t('Message.clickSelectCharacter')"
            @click="clickSelectRole(idx)"
          />
          <div>
            {{ item.bio }}
          </div>
          <button
            class="btn btn-sm self-end mt-4"
            @click="clickRemoveRole(idx)"
          >
            <i class="iconfont icon-delete text-sm"></i>
          </button>
        </div>
      </div>
      <div v-if="store.currentStoryMateList.length === 0">
        <VanEmpty :description="t('Message.noCharactersAvailable')" />
      </div>
    </div>
  </div>

  <VanPopup v-model:show="showSelectRole" position="bottom">
    <VanPicker
      :columns="columns"
      @confirm="onConfirm"
      @cancel="showSelectRole = false"
      :confirm-button-text="t('Buttons.momentSave')"
      :cancel-button-text="t('Buttons.cancel')"
    />
  </VanPopup>
</template>

<script setup lang="ts">
import { useStoryBook } from "@/stores/story-book";
import { PickerConfirmEventParams, showConfirmDialog } from "vant";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useStoryBook();

const showSelectRole = ref(false);
const columnsMap = {
  1: t("story.role.1"),
  2: t("story.role.2"),
};

const columns = [
  { text: t("story.role.1"), value: 1 },
  { text: t("story.role.2"), value: 2 },
];

let activeIdx = 0;
const clickSelectRole = (idx: number) => {
  activeIdx = idx;
  showSelectRole.value = true;
};

const clickRemoveRole = (idx: number) => {
  showConfirmDialog({
    title: t("ConfirmModal.promptTitle"),
    message: t("ConfirmModal.deleteCharacter"),
    confirmButtonText: t("Buttons.confirm"),
    cancelButtonText: t("Buttons.cancel"),
  }).then(() => {
    store.form.characterzz!.splice(idx, 1);
  });
};

const onConfirm = (value: PickerConfirmEventParams) => {
  store.form.characterzz![activeIdx].role = value.selectedOptions[0]!
    .value! as number;
  showSelectRole.value = false;
};
</script>
